var courses_carousel = require('./courses-carousel');
var image_loading = require('./image-loading');

var user_portal = (function( $ ) {

	var $custom_carousel;

	var $taxonomy_carousel;

	var $posts_carousel;

	var $tutor_carousel;

	var $instagram_carousel;

	var $student_cakes_carousel;

	var _init = function() {
		setup_carousels();

		$( document.body ).on( 'portal_block_added', function( event, $elem ) {
			setup_carousels( $elem );
		} );

		$( '.user-portal-row' ).Lazy();
	};

	var setup_carousels = function( $elem ) {
		$elem = typeof $elem !== 'undefined' ? $elem : $(document);

		$custom_carousel = $elem.find( '.custom-carousel' );

		if ( $custom_carousel.length > 0 ) {
			_init_custom_carousel();
		}

		$taxonomy_carousel = $elem.find( '.taxonomy-carousel' );

		if ( $taxonomy_carousel.length > 0 ) {
			_init_taxonomy_carousel();
		}

		$posts_carousel = $elem.find( '.post-carousel' );

		if ( $posts_carousel.length > 0 ) {
			_init_posts_carousel();
		}

		$tutor_carousel = $elem.find( '.tutor-carousel' );

		if ( $tutor_carousel.length > 0 ) {
			_init_tutor_carousel();
		}

		$instagram_carousel = $elem.find( '.instagram-carousel' );

		if ( $instagram_carousel.length > 0 ) {
			_init_instagram_carousel();
		}

		$student_cakes_carousel = $elem.find( '.student-cakes-carousel' );

		if ( $student_cakes_carousel.length > 0 ) {
			_init_student_cakes_carousel();
		}

		courses_carousel.setup( $elem );

		image_loading.add_listeners_for( $elem );
	};

	var _carousel_options = function( responsive ) {
		return {
			loop: true,
			margin: 10,
			nav: true,
			navText: [ '&lt;', '&gt;' ],
			responsive: responsive
		};
	};

	var _init_posts_carousel = function() {
		$posts_carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$posts_carousel.owlCarousel(
			_carousel_options( {
				0: {
					items: 1,
					stagePadding: 20
				},
				600: {
					items: 2,
					stagePadding: 40
				},
				1000: {
					items: 3,
					stagePadding: 40
				},
				1200: {
					items: 3,
					stagePadding: 95
				}
			} )
		);
	};

	var _init_taxonomy_carousel = function() {
		$taxonomy_carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$taxonomy_carousel.owlCarousel(
			_carousel_options( {
				0: {
					items: 1,
					stagePadding: 20
				},
				600: {
					items: 2,
					stagePadding: 40
				},
				1000: {
					items: 3,
					stagePadding: 40
				},
				1200: {
					items: 4,
					stagePadding: 95
				}
			} )
		);
	};

	var _init_custom_carousel = function() {
		$custom_carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$custom_carousel.owlCarousel(
			_carousel_options( {
				0: {
					items: 1
				},
				600: {
					items: 2
				},
				1000: {
					items: 3
				},
				1200: {
					items: 4
				},
				1600: {
					items: 5
				}
			} )
		);
	};

	var _init_tutor_carousel = function() {
		$tutor_carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$tutor_carousel.owlCarousel(
			_carousel_options( {
				0: {
					items: 1
				},
				600: {
					items: 2
				},
				1000: {
					items: 3
				},
				1200: {
					items: 4
				},
				1600: {
					items: 5
				}
			} )
		);
	};

	var _init_instagram_carousel = function() {
		$instagram_carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$instagram_carousel.owlCarousel(
			_carousel_options( {
				0: {
					items: 1
				},
				600: {
					items: 2
				},
				1000: {
					items: 3
				},
				1200: {
					items: 5
				},
				1600: {
					items: 7
				}
			} )
		);
	};

	var _init_student_cakes_carousel = function() {
		$student_cakes_carousel.on( 'initialized.owl.carousel', _slider_initialised );

		$student_cakes_carousel.owlCarousel(
			_carousel_options( {
				0: {
					items: 1
				},
				600: {
					items: 2
				},
				1000: {
					items: 3
				},
				1200: {
					items: 5
				},
				1600: {
					items: 7
				}
			} )
		);
	};

	var _slider_initialised = function( e ) {
		$( this ).find( '.owl-item .item' ).show();
	};

	if ( $( 'body.page-template-user-portal' ).length ) {
		$( _init );
	}

	return {
		setup_carousels: setup_carousels
	};

})( jQuery );

module.exports = user_portal;